import { render, staticRenderFns } from "./BannerResources.vue?vue&type=template&id=288a31b0&scoped=true"
import script from "./BannerResources.vue?vue&type=script&lang=js"
export * from "./BannerResources.vue?vue&type=script&lang=js"
import style0 from "./BannerResources.vue?vue&type=style&index=0&id=288a31b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288a31b0",
  null
  
)

export default component.exports